import React from "react";
import { Helmet } from 'react-helmet-async';
import { Container, Row } from "reactstrap";
import LeftSideContent from "./LeftSideContent";
import ProfileCompletion from "./ProfileCompletion";
import RightSideContent from "./RightSideContent";
import Section from "./Section";

const MyProfile = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>My Profile | Jobseekers Page </title>
      </Helmet>
      <Section />
      <section className="section">
        <Container>
          <ProfileCompletion />
          <Row>
            <LeftSideContent />
            <RightSideContent />
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default MyProfile;
